import React from 'react';
import { Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClock, faAdjust } from '@fortawesome/free-solid-svg-icons';
import { getPaymentStatusMeta } from '../../utils/paymentStatus';

const ICONS = {
  settled: faCheck,
  partial: faAdjust,
  pending: faClock,
  none: faClock,
};

/**
 * Settlement badge used across dashboard, list, and detail.
 */
const PaymentStatusBadge = ({ expense, showRemaining = false, pill = true, className = '' }) => {
  const meta = getPaymentStatusMeta(expense);
  const icon = ICONS[meta.status] || faClock;

  return (
    <span className={`payment-status-badge ${className}`.trim()}>
      <Badge bg={meta.badgeBg} pill={pill} text={meta.badgeBg === 'warning' ? 'dark' : undefined}>
        <FontAwesomeIcon icon={icon} className="me-1" />
        {meta.label}
      </Badge>
      {showRemaining &&
        meta.status === 'partial' &&
        meta.remainingAmount != null &&
        !Number.isNaN(meta.remainingAmount) && (
          <span className="payment-status-remaining text-muted">
            £{parseFloat(meta.remainingAmount).toFixed(2)} left
          </span>
        )}
    </span>
  );
};

export default PaymentStatusBadge;
